import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {
  MarginDirective,
  MarginTopDirective,
  MarginBottomDirective,
  MarginLeftDirective,
  MarginRightDirective,
  MarginHorizontalDirective,
  MarginVerticalDirective
} from './margin.directive';

import {
  PaddingDirective,
  PaddingTopDirective,
  PaddingBottomDirective,
  PaddingLeftDirective,
  PaddingRightDirective,
  PaddingHorizontalDirective,
  PaddingVerticalDirective
} from './padding.directive';

@NgModule({
  declarations: [
    MarginDirective,
    MarginTopDirective,
    MarginBottomDirective,
    MarginLeftDirective,
    MarginRightDirective,
    MarginHorizontalDirective,
    MarginVerticalDirective,
    PaddingDirective,
    PaddingTopDirective,
    PaddingBottomDirective,
    PaddingLeftDirective,
    PaddingRightDirective,
    PaddingHorizontalDirective,
    PaddingVerticalDirective,
  ],
  exports: [
    MarginDirective,
    MarginTopDirective,
    MarginBottomDirective,
    MarginLeftDirective,
    MarginRightDirective,
    MarginHorizontalDirective,
    MarginVerticalDirective,
    PaddingDirective,
    PaddingTopDirective,
    PaddingBottomDirective,
    PaddingLeftDirective,
    PaddingRightDirective,
    PaddingHorizontalDirective,
    PaddingVerticalDirective,
  ],
  imports: [CommonModule]
})
export class SpacingModule { }
